import React from 'react';
import CircularButton from '../CircularButton/CircularButton';
import CloseButton from '../CloseButton/CloseButton';
import PrimaryButton from '../PrimaryButton/PrimaryButton';
import CancelButton from '../CancelButton/CancelButton';


class AddAppointment extends React.Component {
    constructor() {
        super();
        this.state = { 
            collapsed: true,
            date: new Date(),
            hour: null,
            minute: null,
            notes:null,
        };
    }

    onSave = () => {
        const {date, hour, minute, notes} = this.state;
        //TODO: Agregar validacion de hora y minutos validos
        if(date === "" || date === null){
            this.setState({isError:true});
            return;
        }
    
        if(notes === "" || notes === null){
            this.setState({isError:true});
            return;
        }
    
        if(hour === "" || hour === null){
            this.setState({isError:true});
            return;
        }
    
        if(minute === "" || minute === null){
            this.setState({isError:true});
            return;
        }

        this.setState({isError:false});
        
        this.props.onSave({date: date, hour:hour, minute: minute, notes:notes});

        this.setState({
            collapsed: true,
            date: new Date(),
            hour: null,
            minute: null,
            notes:null,
        });
    }

    addHandler = () => {
        this.setState({collapsed:false})
    }

  render() {
    const {collapsed, date, hour, minute, notes, isError} = this.state;

    if(collapsed){
        return (
            <div className="row">
                <div className="col-md-12 text-right">
                    <CircularButton
                        onClick={this.addHandler}
                        icon="fa fa-plus"
                    />
                </div>
            </div>
        )
    }
    return (
        <div className="row">
            <div className="col-md-12">
                <div className="row">
                    <div className="form-group col-md-4">
                        <label>Fecha</label>
                        <input 
                            className="form-control"
                            type="date" 
                            onChange={(evt) => this.setState({date: evt.target.value})} 
                            value={date}></input>
                    </div>
                    <div className="form-group col-md-4">
                        <label>Hora</label>
                        <input 
                            className="form-control"
                            type="number" 
                            placeholder="hora" 
                            onChange={(evt) =>{
                                const {value} = evt.target;
                                if(value > 0 && value <= 23){
                                    this.setState({hour: value});
                                }else{
                                    this.setState({hour: ""});
                                }
                            }}  
                            value={hour}></input>

                    </div>
                    <div className="form-group col-md-4">
                        <label>Minuto</label>
                        <input
                            className="form-control" 
                            type="number" 
                            placeholder="minuto" 
                            onChange={(evt) => {
                                const {value} = evt.target;
                                if(value > 0 && value <= 59){
                                    this.setState({minute: value});
                                }else{
                                    this.setState({minute: ""});
                                }
                            }} 
                            value={minute}></input>
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Notas</label>
                        <textarea 
                            className="form-control"
                            onChange={(evt) => this.setState({notes: evt.target.value})} 
                            value={notes}>
                        </textarea>
                    </div>
                </div>
                {isError ?
                    <div className="row">
                        <div className="col-md-12">
                            <p className="error">Recuerda que todos los campos son obligatorios</p>
                        </div>
                    </div> 
                    :
                    null
                }
                <div className="row">
                    <div className="col-md-3 col-md-offset-6 text-right">
                        <CancelButton
                            onClick={()=> this.setState({collapsed:true})}
                            text="Cancelar"
                        ></CancelButton>
                    </div>
                    <div className="col-md-3 text-right">
                        <PrimaryButton 
                            onClick={this.onSave}
                            text="Guardar"/> 
                    </div>
                </div>
            </div>
        </div>
    )
  }

  
}

export default AddAppointment;



// WEBPACK FOOTER //
// ./src/views/Components/Presentation/AddAppointment/AddAppointment.js